import api from './apiClient';

export const ordersAPI = {
  async getByUser(userId) {
    try {
      return await api.get(`/orders/user/${userId}`);
    } catch (error) {
      console.error('Error loading user orders:', error);
      throw error;
    }
  },

  async create(orderData) {
    try {
      return await api.post('/orders', orderData);
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  async createFromCart(buyerId, cartItems, currencyCode = 'USD') {
    try {
      return await api.post('/orders/from-cart', cartItems, {
        params: {
          buyerId,
          currencyCode,
        },
      });
    } catch (error) {
      console.error('Error creating order from cart:', error);
      throw error;
    }
  },
};

export default ordersAPI;

